module.exports = __webpack_public_path__ + "static/media/melo1.05a5a104.ogg";